import type { RawContent } from './schema'

// Content data read by the sim core via loadContent(). Buildings, recipes and
// items are rows: adding a building or recipe is a data edit here, not a code
// change. Ids are stable and must not be renamed or reused.

export const BUNDLED_CONTENT: RawContent = {
  items: [{ id: 'item.raw_ore' }, { id: 'item.metal_plate' }],
  recipes: [
    // Extractor: consumes nothing, tops up raw ore from an infinite patch.
    // ticks/bufferCap are the watchability tuning: 30 ticks per unit, a stock of
    // 4 so several haulers can work the chain head at once.
    {
      id: 'recipe.mine_ore',
      output: 'item.raw_ore',
      fromPatch: true,
      ticks: 30,
      bufferCap: 4,
    },
    // Converter: one raw ore in, one metal plate out, 45 ticks per batch.
    {
      id: 'recipe.smelt_plate',
      input: 'item.raw_ore',
      output: 'item.metal_plate',
      ticks: 45,
    },
    // Pure sink: consumes the finished plate, produces nothing.
    { id: 'recipe.store_plate', input: 'item.metal_plate', sink: true },
  ],
  buildings: [
    // accessSlots keeps a small cap so surplus haulers queue visibly.
    { id: 'building.mine', recipe: 'recipe.mine_ore', accessSlots: 2 },
    { id: 'building.smelter', recipe: 'recipe.smelt_plate', accessSlots: 2 },
    { id: 'building.storage', recipe: 'recipe.store_plate', accessSlots: 1 },
  ],
  patches: [
    // The ore field the mine sits on: yields raw ore, one extraction slot
    // (default). extractionSlots omitted → a second extractor tapping this patch
    // idles, the throughput cap that later forces reaching distant patches.
    { id: 'patch.ore_field', item: 'item.raw_ore' },
  ],
}

/** Default chain order: mine → smelter → storage. */
export const STARTER_CHAIN: ReadonlyArray<string> = [
  'building.mine',
  'building.smelter',
  'building.storage',
]
